import React from 'react';
import { List } from '@mui/material';
import { motion } from 'framer-motion';
import { isParentNav, NavItemData } from '@/config';
import { NavigationItem } from './NavigationItem';
import { useIsVerified } from '@/modules/userConfig';
import { useCleanPathname } from '@ianesthesie-kit/core';

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

export interface NavigationListProps {
  navItems: NavItemData[];
}

export const NavigationList = ({ navItems }: NavigationListProps) => {
  const pathname = useCleanPathname()!;
  const isUserVerified = useIsVerified();

  return (
    <List component={motion.ul} variants={variants}>
      {navItems.map((nav) => (
        <NavigationItem
          key={isParentNav(nav) ? nav.parentPath : nav.path}
          navItem={nav}
          disabled={nav.verifiedOnly && !isUserVerified}
          currentRoute={pathname}
        />
      ))}
    </List>
  );
};
